import type { UseMutationOptions, UseQueryOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';
import type { IUserSignUpData } from 'api/types/user';

interface ISignUpResponse {
    redirectUrl: string;
}

export interface IUpdateUserProps
    extends UseQueryOptions<IUserSignUpData, IRequestException> {
    data: IUserSignUpData | {};
}

const signUpUser = async ({ data }: IUpdateUserProps) => {
    const response = await apiClient.post('signups', {
        json: { ...data },
    });

    return (await response.json()) as ISignUpResponse;
};

export const useSignUpMutation = (
    options: UseMutationOptions<
        ISignUpResponse,
        IRequestException,
        IUpdateUserProps
    >
) => {
    return useMutation<ISignUpResponse, IRequestException, IUpdateUserProps>(
        async (data) => await signUpUser(data),
        options
    );
};
